<template>
  <a href="javascript:;">
    <span
      v-b-tooltip.hover
      title="Turn on the account"
      class="float-right turn-button"
      @click="handleOffInvestor(investor.info.token, 0)"
      v-if="on"
    >
      <b-icon-toggle-on class="text-success"></b-icon-toggle-on>
    </span>
    <span
      v-b-tooltip.hover
      title="Turn off the account"
      class="float-right turn-button"
      @click="handleOffInvestor(investor.info.token, 1)"
      v-else
    >
      <b-icon-toggle-off class="text-success"></b-icon-toggle-off>
    </span>
  </a>
</template>
<script>
import handleSocket from "@/helpers/socket";

export default {
  name: "ToggleOnOffAccount",
  props: {
    investor: {
      required: true,
      type: Object,
      default: () => {
        {
        }
      },
    },
    token: {
      required: true,
      type: String,
    },
  },
  created() {
    if (
      this.$props.investor.info.investor.status == 2 ||
      this.$props.investor.info.investor.status == 1
    ) {
      this.on = true;
    } else {
      this.on = false;
    }
    this.$emit("handleUpdateIsOn", this.on);
  },
  data() {
    return {
      first: true,
      on: false,
      success: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="20" height="20" rx="10" fill="#8BF125" fill-opacity="0.3"/>
          <g clip-path="url(#clip0_1634_940)">
          <path d="M14.2995 6.84625L8.5416 12.6038C8.50288 12.6426 8.45688 12.6735 8.40622 12.6945C8.35556 12.7155 8.30124 12.7264 8.24639 12.7264C8.19153 12.7264 8.13722 12.7155 8.08656 12.6945C8.0359 12.6735 7.98989 12.6426 7.95118 12.6038L5.72451 10.375C5.6858 10.3361 5.63979 10.3053 5.58913 10.2843C5.53848 10.2632 5.48416 10.2524 5.4293 10.2524C5.37445 10.2524 5.32013 10.2632 5.26947 10.2843C5.21881 10.3053 5.17281 10.3361 5.1341 10.375C5.09523 10.4137 5.06439 10.4597 5.04335 10.5104C5.02231 10.561 5.01147 10.6154 5.01147 10.6702C5.01147 10.7251 5.02231 10.7794 5.04335 10.83C5.06439 10.8807 5.09523 10.9267 5.1341 10.9654L7.3616 13.1925C7.59657 13.427 7.91501 13.5588 8.24701 13.5588C8.57901 13.5588 8.89745 13.427 9.13243 13.1925L14.8899 7.43625C14.9287 7.39755 14.9595 7.35157 14.9805 7.30095C15.0015 7.25033 15.0123 7.19606 15.0123 7.14125C15.0123 7.08645 15.0015 7.03218 14.9805 6.98156C14.9595 6.93094 14.9287 6.88496 14.8899 6.84625C14.8512 6.80739 14.8052 6.77655 14.7546 6.75551C14.7039 6.73446 14.6496 6.72363 14.5947 6.72363C14.5399 6.72363 14.4855 6.73446 14.4349 6.75551C14.3842 6.77655 14.3382 6.80739 14.2995 6.84625Z" fill="#1D1E25"/>
          </g>
          <defs>
          <clipPath id="clip0_1634_940">
          <rect width="10" height="10" fill="white" transform="translate(5 5)"/>
          </clipPath>
          </defs>
          </svg> Success`,
      url_socket: "investors_status",
    };
  },
  methods: {
    sendConnect() {
      this.doSend(this.$props.investor.info.token);
      this.doSend(this.$props.investor.info.investor.is_real.toString());
    },
    onOpen() {
      if (!this.$props.investor.info) {
        let interval = setInterval(() => {
          if (this.$props.investor.info) {
            clearInterval(interval);
            this.sendConnect();
          }
        }, 250);
      } else {
        this.sendConnect();
      }
    },
    onClose(evt) {
      this.writeToScreen("DISCONNECTED");
    },
    onMessage(evt) {
      if (evt.data) {
        let payload = JSON.parse(evt.data);
        if (!this.first) {
          if (this.on && !payload.status) {
            if (this.$props.token === this.$props.investor.info.token) {
              this.$toastr.success("Success account off. ", `${this.success}`);
            }
          } else if (!this.on && payload.status) {
            if (this.$props.token === this.$props.investor.info.token) {
              this.$toastr.success("Success account on. ", `${this.success}`);
            }
          }
          this.on = payload.status;
        } else {
          this.first = false;
          this.on = payload.status;
        }

        if (this.$props.token === this.$props.investor.info.token) {
          this.$emit("handleUpdateIsOn", this.on);
        }
      } else {
        console.log(evt);
      }
    },
    onError(evt) {
      console.error(evt);
    },
    doSend(message) {
      this.websocket.send(message);
    },
    writeToScreen(message) {
      console.log("writeToScreen", message);
    },
    handleOffInvestor(token, on_off) {
      const payload = {
        vm: this,
        data: {
          investor_token: token,
          on: on_off,
        },
      };
      this.$store.commit("handle_toggle_account", payload);
      this.$toastr.success(
        "Request sent, please wait for its update.",
        `${this.success}`
      );
    },
  },
  watch: {
    "$store.state.turn_accounts"(value) {
      if (value) {
        const investors = this.$store.state.select_accounts.filter(
          (investor) => investor.info.token === this.$props.token
        );
        if (investors.length > 0) {
          console.log("aqui empieza todo");
          console.log(this.$props.token);
          let turn = 0;
          if (
            this.$props.investor.info.investor.status == 2 ||
            this.$props.investor.info.investor.status == 1
          ) {
            this.on = true;
            turn = 0;
          } else {
            this.on = false;
            turn = 1;
          }
          console.log(turn);
          this.$store.commit(
            "unselect_investor_from_select",
            this.$props.token
          );
          this.handleOffInvestor(this.$props.token, turn);
        }
      }
    },
  },
};
</script>
